import { getTrait } from '@aytm/app/stats/lib/stat-page'

// Zoom button state, 1:1 with coffee highchart_view (isZoomType / renderZoomLevel /
// toggleZoomLevel). Pure derivation — extremes themselves are baked by the builder.
export const useZoom = ({ zoom, zoomType, ignoreTraits, zoomLevel, globalZoomLevel }) => {
  // zoom gate uses the narrow page-level trait, not the broad trait prop with its
  // survey.variables fallbacks
  const trait = getTrait()

  const isZoomEnabled = Boolean(zoom) && Boolean(zoomType) && ((trait != null && ignoreTraits) || trait == null)
  if (!isZoomEnabled) return { isZoomEnabled: false }

  const effectiveLevel = zoomLevel || globalZoomLevel // per-question overrides global; `||` like coffee

  const isMax = effectiveLevel === 'max'
  const isWarning = zoom.currentMax <= zoom.seriesMin || zoom.currentMin >= zoom.seriesMax
  const isDisabled =
    zoom.dataMin === zoom.axisMin &&
    zoom.dataMax === zoom.axisMax &&
    zoom.currentMin === zoom.axisMin &&
    zoom.currentMax === zoom.axisMax
  const title = isMax ? 'Zoom in to best fit' : 'Zoom out to full scale'

  const getToggleTarget = () => {
    if (effectiveLevel === 'min') return 'max'
    if (effectiveLevel === 'max') return 'min'
    return globalZoomLevel // custom [min, max] range → back to the global level
  }

  return { isZoomEnabled, isMax, isWarning, isDisabled, title, getToggleTarget }
}
